import { ValidationReturnType } from "../types";

export function requiredFieldRule(): ValidationReturnType {
	return {
		rules: {
			required: true,
		},
	};
}

export function requiredQuestionDifficult(): ValidationReturnType {
	return {
		rules: {
			min: 1,
			max: 10,
		},
	};
}
